export const OOD_COLORS_LIST = ['blue', 'purple', 'red', 'orange', 'yellow', 'green', 'cyan', 'grey', 'pink', 'darkGreen'] as const;
export type OodColors = (typeof OOD_COLORS_LIST)[number];

export type OodColorVariant = {
	background: string | undefined;
	border: string | undefined;
	content: string | undefined;
};
